export const NewsLetterUserEmailsAPI =
  "https://catalogmaker.in/API/EmailList.php";
